export { cn } from '@sizzlenz/shared-frontend/utils';

export function extractTagValue(tags: string[], tagStartsWith: string) {
  const tag = tags?.find((tag) => tag.startsWith(tagStartsWith));
  if (!tag) return null;
  const value = tag.split(tagStartsWith)[1].trim();
  return value;
}

/**
 * Resolve the display date for a content item.
 * Priority: displayPublishedAt → liveStart → createdAt
 */
export function getContentDisplayDate(content: {
  displayPublishedAt?: string | null;
  liveStart?: string | null;
  createdAt?: string | null;
}): string | null {
  return content.displayPublishedAt || content.liveStart || content.createdAt || null;
}

export { toast } from '@/components/ui/sonner';

/** Build the public URL for a content item, preferring slug over id. */
export function getContentUrl(content: { id: number; slug?: string | null }): string {
  return `/content/${content.slug || content.id}`;
}
